import React from "react";
import { IconChecklist } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { numberFormat } from "../../../helpers/numberFormat";

const ModalConfirmSkipEarlyBird = (props) => {
  const np = useSelector((state) => state.nominalPayment);
  //   console.log(np.nominalPayment);
  return (
    <>
      <div className="row mb-3">
        <div
          className="card mb-3"
          style={{
            backgroundColor: "#F8F5FF",
            marginBottom: "15px",
            borderColor: "#8e44ad",
          }}
        >
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-12 d-flex">
                <div className="col-lg-2 col-12">
                  <IconChecklist
                    width="65px"
                    height="65px"
                    style={{ color: "#8e44ad" }}
                  />
                </div>
                <div className="col-lg-10 col-12">
                  <div className="row">
                    <h4 style={{ color: "#8e44ad" }}>
                      Konfirmasi Pembayaran Tanpa Diskon Early Bird
                    </h4>
                  </div>
                  <div className="row">
                    <p style={{ fontSize: "12px" }}>
                      1. Anda memilih untuk melanjutkan{" "}
                      <b>
                        tanpa memakai diskon <i>Early Bird</i>.
                      </b>
                    </p>
                    <p style={{ fontSize: "12px" }}>
                      2. <b>Pembayaran</b> akan dilakukan setelah program
                      selesai, silahkan{" "}
                      <b>
                        mengupload Guarantee Letter (GL) maksimal H-1 program
                        dilaksanakan
                      </b>
                      .
                    </p>
                    <p style={{ fontSize: "12px" }}>
                      3. Untuk <b>bukti pembayaran</b> dapat diupload di bagian
                      Dashboard Transaksi <b>maksimal 14 hari</b> setelah
                      invoice diterima.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="card mb-3"
          style={{
            backgroundColor: "#f2f3f4",
            marginBottom: "15px",
          }}
        >
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-12">
                <h4 className="mb-3">Ringkasan Pembayaran</h4>
                <div className="d-flex justify-content-between mb-2">
                  <p>Sub Total</p>
                  <p>Rp. {numberFormat(np.nominalPayment.amount)}</p>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <p>PPN (12%)</p>
                  <p>Rp. {numberFormat(np.nominalPayment.ppn)}</p>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <p>Potongan Harga</p>
                  <p className="text-danger">
                    Rp. {numberFormat(np.nominalPayment.deduction)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <h3>Total</h3>
          <h3 style={{ color: "#0C86D9" }}>
            Rp. {numberFormat(np.nominalPayment.grandtotal)}
          </h3>
        </div>
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-outline-primary"
            style={{ marginRight: "15px" }}
            onClick={props.activateEarlyBird}
          >
            Kembali dan Pakai Diskon
          </button>
          &nbsp;
          <button className="btn btn-success" onClick={props.nextToGlPage}>
            Upload Guarantee Letter
          </button>
        </div>
      </div>
    </>
  );
};

export default ModalConfirmSkipEarlyBird;
